/**
 * KID PROFILE — the Iron Man / JARVIS Gemini-Live console for Child.
 *
 * TRUE KIOSK: the forked demo's <SidePanel/> (dev log) and <ControlTray/> (mic /
 * webcam / screen-share / connect buttons, "Google Sans") are REMOVED so the whole
 * surface is one design language — the glyph is the only control ("glyph is the mode
 * indicator, no labels"). ControlTray's one load-bearing job, mic capture, now lives
 * headless in useMicStream (mounted inside KidMode). This is the ONLY profile that
 * mounts the Live API; App.tsx routes here when profile === "kid".
 */
import { LiveAPIProvider } from "../contexts/LiveAPIContext";
import { KidMode } from "../kid/KidMode";
import { LiveClientOptions } from "../types";

const API_BASE = process.env.REACT_APP_API_BASE ?? "";
// Dev-only fallback. In production the key is NOT in the browser — the server
// mints a fresh short-lived token below (set GEMINI_API_KEY on the server).
const API_KEY = (process.env.REACT_APP_GEMINI_API_KEY as string) || "";

/**
 * Preferred path: ask OUR server for a fresh, short-lived EPHEMERAL token. The
 * server holds the real Gemini key; it never ships in this bundle. Returns null
 * on failure so the client falls back to the static dev key (if one is set).
 */
async function fetchGeminiToken(): Promise<string | null> {
  try {
    const r = await fetch(`${API_BASE}/api/gemini_token`, { method: "GET" });
    if (!r.ok) return null;
    const d = await r.json();
    return typeof d?.token === "string" && d.token ? d.token : null;
  } catch {
    return null;
  }
}

const apiOptions: LiveClientOptions = {
  apiKey: API_KEY, // dev fallback only — production uses the ephemeral token
  getEphemeralToken: fetchGeminiToken,
  // Les tokens éphémères Gemini exigent l'API v1alpha (sinon "API key not valid").
  httpOptions: { apiVersion: "v1alpha" },
};

export default function KidProfile() {
  return (
    <LiveAPIProvider options={apiOptions}>
      <KidMode />
    </LiveAPIProvider>
  );
}
